import React, { JSX } from "react";
import "./ConfirmationModal.css";

type ConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'danger' | 'primary';
  loading?: boolean;
};

export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = 'danger',
  loading = false
}: ConfirmationModalProps): JSX.Element | null {
  if (!open) return null;

  return (
    <div className="confirmation-modal">
      <div className="overlay" onClick={loading ? undefined : onClose} />
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirmation-modal-title">{title}</h3>
        <p className="confirmation-modal-message">{message}</p>
        
        <div className="confirmation-modal-actions">
          <button 
            className="confirmation-modal-button cancel" 
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            className={`confirmation-modal-button confirm ${confirmVariant}`} 
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
